import React, { useMemo, useState } from 'react';
import { ElementsRenderer } from '../../shared';
import { debounce } from 'lodash';
import { useContextEffect } from '../../../hooks';
import TiptapCodeEditor from './tiptap-editor';
import { TEXT_TYPE } from '../../../constants';
import ReadingComprehensionElement from './ReadingComprehensionElement';

const SubjectiveQuestionBody = ({
  elements,
  answer: savedAnswer,
  questionId,
  updateAnswer,
  updateAndSaveAnswer,
  readingComprehensionQuestionRef
}) => {
  const [answer, setAnswer] = useState('');

  const saveDebounced = useMemo(() => debounce(updateAndSaveAnswer, 3000), [updateAndSaveAnswer]);

  useContextEffect({
    deps: [],
    ctx: { savedAnswer },
    cb: (ctx) => {
      setAnswer(ctx.savedAnswer?.[0] || '');

      return () => {
        saveDebounced.cancel();
      };
    }
  });

  const answerChanged = (html) => {
    setAnswer(html);
    updateAnswer(questionId, html);
    saveDebounced(questionId, html);
  };

  return (
    <div className="katex-question w-full space-y-4 md:space-y-6">
      {readingComprehensionQuestionRef && (
        <ReadingComprehensionElement questionRef={readingComprehensionQuestionRef} />
      )}

      <div className="question-container text-base leading-relaxed text-foreground md:text-lg">
        <ElementsRenderer elements={elements} textType={TEXT_TYPE.TIPTAP} />
      </div>

      <TiptapCodeEditor
        onUpdate={answerChanged}
        value={answer}
        textPlaceholder="Write your detailed answer here..."
        autofocus
        editorVariant="subjective"
      />
    </div>
  );
};

export default SubjectiveQuestionBody;
